import { ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewContainerRef, ViewRef } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ConsignmentEntry } from '@spartacus/cart/base/root';
import { BaseSiteService, LanguageService } from '@spartacus/core';
import { Consignment } from '@spartacus/order/root';
import { Observable, Subscription, combineLatest } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';
import { CUSTOM_LAUNCH_CALLER } from 'src/app/dialog/custom-launch-dialog-config';
import { CheckoutConstants } from 'src/app/model/checkout.model';
import { DealerPrice } from 'src/app/model/dealer-price.model';
import { OrderDetailsEnum } from 'src/app/model/order-details.model';
import { BaseStoreService } from 'src/app/service/base-store/base-store.service';
import { CheckoutServiceExtends } from 'src/app/service/checkout/checkout.service';
import { ComponentService } from 'src/app/service/component.service';
import { ShimanoCountryService } from 'src/app/service/country/shimano-country.service';
import { DealerPriceService } from 'src/app/service/dealer-price/dealer-price.service';
import { CustomTranslationService } from 'src/app/service/language/custom-translation.service';
import { StandardModalService } from 'src/app/service/modal/standard-modal.service';
import { PermissionsConstants } from 'src/app/service/myaccount/my-account-permission.constants';
import { MyAccountPermissionService } from 'src/app/service/myaccount/my-account-permission.service';
import { MyaccountPersonalInfoService } from 'src/app/service/myaccount/myaccount-personal-info.service';
import { OrderDetailsService } from 'src/app/service/myaccount/order-details.service';
import { OrderHistoryService } from 'src/app/service/orders/order-history.service';
import { CustomProductService } from 'src/app/service/product/custom-product.service';
import { StorageService } from 'src/app/service/storage/storage.service';
import { ORDER_HISTORY_DETAILS, TooltipIconService } from 'src/app/service/tooltip-icon/tooltip-icon.service';
import { CurrentBusinessType } from 'src/app/utility/current-businesstype';
import { ShimanoUtilMethod } from 'src/app/utility/methods.util';

export enum OrderDetailsConsignmentsStatus {
  WAITING_PLANNED = '1',
  IN_PREPARATION = '2',
  SHIPPED = '3',
  BACKORDER = '4',
  CANCELLED = '5',
}

@Component({
  selector: 'app-order-details-consignments',
  templateUrl: './order-details-consignments.component.html',
  styleUrls: ['./order-details-consignments.component.scss'],
  standalone: false,
})
export class OrderDetailsConsignmentsComponent implements OnInit, OnDestroy {
  orders$: Observable<any>;
  showSrp = false;
  orderId: string;
  srpSubscription$: Subscription;
  baseStoreSubscription$: Subscription;
  dateFormatted: string;
  baseSite$: Observable<string> = this.baseService.getActive();
  skipVariantCategory: string;
  default = 'default';

  orderDetailsSubscription$: Subscription;
  // custom Order type
  order: any;
  consignmentsStatus = OrderDetailsConsignmentsStatus;

  hasDealerPrice = true;
  dealerPrices: DealerPrice[];
  dealerPriceCheckerSubscription$: Subscription;
  storeFrontPermissionsSubscription$: Subscription;
  hasItemEditable: boolean;
  allItemsEditable: boolean;
  isOrderClosed: boolean;
  cancelOrdersAllowed: boolean;
  editOrdersAllowed: boolean;
  features: any = {};
  consignmentEntryControl = new FormControl(null, Validators.required);
  activeCountry$: Observable<string> = this.countryService.getActive();
  activeLanguage$: Observable<string> = this.languageService.getActive();

  tooltipIconConfig$: Observable<any> = this.activeCountry$.pipe(
    take(1),
    switchMap((activeCountry) => this.tooltipIconService.getTooltipIconConfig(activeCountry, ORDER_HISTORY_DETAILS))
  );

  showGstExclusive$: Observable<boolean> = this.activeCountry$.pipe(
    take(1),
    switchMap((activeCountry) =>
      this.checkoutServiceExtends.isCheckoutFeatureEnabled$(activeCountry, CheckoutConstants.GST_EXCLUSIVE)
    )
  );

  showGstInclusive$: Observable<boolean> = this.activeCountry$.pipe(
    take(1),
    switchMap((activeCountry) =>
      this.checkoutServiceExtends.isCheckoutFeatureEnabled$(activeCountry, CheckoutConstants.GST_INCLUSIVE)
    )
  );

  isDownloadInvoiceEnabled$: Observable<boolean> = this.activeCountry$.pipe(
    take(1),
    switchMap((activeCountry) =>
      this.checkoutServiceExtends.isCheckoutFeatureEnabled$(activeCountry, CheckoutConstants.DOWNLOAD_INVOICE)
    )
  );

  isDownloadTrackAndTraceEnabled$: Observable<boolean> = this.activeCountry$.pipe(
    take(1),
    switchMap((activeCountry) =>
      this.checkoutServiceExtends.isCheckoutFeatureEnabled$(activeCountry, CheckoutConstants.DOWNLOAD_TRACK_AND_TRACE)
    )
  );

  isTrackingIdEnabled$: Observable<boolean> = this.activeCountry$.pipe(
    take(1),
    switchMap((activeCountry) =>
      this.checkoutServiceExtends.isCheckoutFeatureEnabled$(activeCountry, CheckoutConstants.TRACKING_ID)
    )
  );

  isCustomTranslationsEnabled$: Observable<boolean> = combineLatest([this.activeCountry$, this.activeLanguage$]).pipe(
    switchMap(([activeCountry, activeLanguage]) =>
      this.customTranslationService.isCustomTranslationsEnabled$(activeCountry, activeLanguage, [
        'cart.cartItem.quantity',
      ])
    )
  );
  businessType: string;

  isActiveCountrySSSC$: Observable<boolean> = this.activeCountry$.pipe(
    take(1),
    map((activeCountry) => activeCountry === 'cn')
  );

  constructor(
    protected orderDetailsService: OrderDetailsService,
    private componentService: ComponentService,
    private cdr: ChangeDetectorRef,
    public baseStoreService: BaseStoreService,
    private baseService: BaseSiteService,
    private customProductService: CustomProductService,
    private dealerPriceService: DealerPriceService,
    private countryService: ShimanoCountryService,
    private languageService: LanguageService,
    private customTranslationService: CustomTranslationService,
    private tooltipIconService: TooltipIconService,
    private checkoutServiceExtends: CheckoutServiceExtends,
    private currentBusinesstype: CurrentBusinessType,
    private storageService: StorageService,
    private myAccountPermissionService: MyAccountPermissionService,
    private myAccountPersonalInforService: MyaccountPersonalInfoService,
    protected modalService: StandardModalService,
    private el: ElementRef,
    private vcr: ViewContainerRef,
    private route: ActivatedRoute,
    private orderHistoryService: OrderHistoryService
  ) {
    this.baseStoreService
      .getBasestoreData()
      .pipe(take(1))
      .subscribe((baseStoreData) => {
        this.dateFormatted = baseStoreData.dateFormat.replace(/\//g, '-');
        this.cdr.detectChanges();
      });

    this.customProductService
      .getSkipVariant()
      .pipe(take(1))
      .subscribe((resp) => {
        this.skipVariantCategory = resp[this.baseSiteId]
          ? resp[this.baseSiteId].defaultVariantCategory
          : resp[this.default].defaultVariantCategory;
      });
    // get customized order history features
    this.orderHistoryService
      .getFeatures()
      .pipe(take(1))
      .subscribe((features: any) => {
        this.features = { ...features, ...this.features };
        this.cdr.detectChanges();
      });
  }

  get baseSiteId(): string {
    let baseSiteId: string;
    this.baseSite$.pipe(take(1)).subscribe((baseSiteData) => (baseSiteId = baseSiteData));
    return baseSiteId;
  }

  ngOnInit() {
    this.orderDetailsSubscription$ = this.componentService.orderDetails$.subscribe((orderDetails) => {
      this.order = orderDetails;
      this.addFeatures(orderDetails);
      const productCodes = orderDetails.consignments
        .map((consignment: Consignment) =>
          consignment.entries.map((consignmentEntry: ConsignmentEntry) => consignmentEntry.orderEntry.product.code)
        )
        .flat();
      this.getDealerPrices(productCodes);
      this.checkOrderEditable(orderDetails);
      this.cdr.detectChanges();
    });

    this.getInitSrpToggleValue();

    this.srpSubscription$ = this.componentService.srpToggle$.subscribe((checked) => {
      this.showSrp = checked;
      this.cdr.detectChanges();
    });

    this.dealerPriceCheckerSubscription$ = this.componentService.hasDealerPrice$.subscribe((hasDealerPrice) => {
      this.hasDealerPrice = hasDealerPrice;
      if (!(this.cdr as ViewRef).destroyed) {
        this.cdr.detectChanges();
      }
    });
    this.businessType = this.currentBusinesstype.getBusinessType();
    this.getCancelEditOrderPermission();
  }

  checkVariant(variants: any) {
    return variants
      .filter((variant: any) => {
        if (variant.code !== this.skipVariantCategory) {
          return variant;
        }
      })
      .slice(0, 3);
  }

  getInitSrpToggleValue() {
    this.showSrp = this.storageService.getLocalStorageItem('showSrp') === 'true';
  }

  getImageRendition(image: any) {
    let size: string;
    size = ShimanoUtilMethod.imageRendition(80);
    return ShimanoUtilMethod.newImageFormat(image, size);
  }

  getStatusIcon(statusCode: string) {
    let statusIcon: string;
    switch (statusCode) {
      case OrderDetailsConsignmentsStatus.WAITING_PLANNED:
      case OrderDetailsConsignmentsStatus.IN_PREPARATION:
        statusIcon = 'open';
        break;
      case OrderDetailsConsignmentsStatus.SHIPPED:
        statusIcon = 'closed';
        break;
      case OrderDetailsConsignmentsStatus.BACKORDER:
        statusIcon = 'back-order';
        break;
      case OrderDetailsConsignmentsStatus.CANCELLED:
        statusIcon = 'cancelled';
        break;
    }
    if (this.cancelOrdersAllowed || this.editOrdersAllowed) {
      switch (statusCode) {
        case OrderDetailsConsignmentsStatus.CANCELLED:
          statusIcon = 'cancelled-x-icon';
          break;
      }
    }
    return statusIcon;
  }

  getDealerPrices(productCodes: string[]) {
    this.dealerPriceService
      .getDealerPricesByProductCodes(productCodes)
      .pipe(take(1))
      .subscribe((data) => {
        this.dealerPrices = data.dealerPrices;
        this.cdr.detectChanges();
      });
  }

  dealerPrice(productCode: string): string {
    if (this.dealerPrices) {
      return this.dealerPriceService.getDealerPriceByProductCode(this.dealerPrices, productCode);
    }
  }

  setCustomContext(isCustomTranslationsEnabled: boolean, activeCountry: string, activeLanguage: string) {
    return isCustomTranslationsEnabled ? [activeCountry, activeLanguage].join('-') : null;
  }

  longQtyText(activeCountry: any, activeLanguage: any): boolean {
    return activeCountry === 'pl' && activeLanguage === 'en';
  }

  toggleCancelEditModal(modalType: string, lineItemEntry?: any, data?: any) {
    let translatables: {};
    let changeOrderEntries;
    let erpOrderType;

    this.route.queryParams.pipe(take(1)).subscribe((data) => (erpOrderType = data?.erpOrderType));

    if (lineItemEntry?.changesPending) {
      return;
    }

    switch (modalType) {
      case OrderDetailsEnum.CANCEL_SELECTED_ITEMS_MODAL:
        changeOrderEntries = lineItemEntry ? [lineItemEntry] : this.consignmentEntryControl.value;
        translatables = {
          modalTitle: { key: 'modal.cancelItems' },
          modalDesc: { key: 'modal.cancelItemsDesc' },
        };
        break;
      case OrderDetailsEnum.CANCEL_WHOLE_ORDER_MODAL:
        translatables = {
          modalTitle: { key: 'modal.cancelWholeOrder' },
          modalDesc: { key: 'modal.cancelWholeOrderDesc' },
        };
        break;
      case OrderDetailsEnum.EDIT_ITEM_QTY_MODAL:
        changeOrderEntries = [lineItemEntry];
        translatables = {
          modalTitle: { key: 'modal.editOrderItemQty' },
        };
        break;
      default:
        return;
    }
    this.modalService
      .openDialog(CUSTOM_LAUNCH_CALLER.CANCEL_EDIT_ORDER, this.el, this.vcr, {
        modalType: modalType,
        translatables: translatables,
        data: data,
        changeOrderEntries: changeOrderEntries,
        order: this.order,
        erpOrderType: erpOrderType,
      })
      ?.pipe(take(1))
      .subscribe();
  }

  getEditItemModalData(item: any): any {
    const data = {
      image: item.orderEntry?.product?.images
        ? this.getImageRendition((item.orderEntry?.product?.images)[0])
        : { src: 'https://via.placeholder.com/72' },
      code: item.orderEntry?.product?.code,
      name: item.orderEntry?.product?.name,
      globalVariant: item.orderEntry?.product?.superCategories
        ? this.checkVariant(item?.orderEntry?.product?.superCategories)
        : null,
      dealerPrice: item.orderEntry?.product?.price?.formattedValue,
      showGstExclusive$: this.showGstExclusive$,
      qty: item.orderEntry?.quantity,
    };
    return data;
  }

  checkOrderEditable(order: any): void {
    let orderItems = this.getAllConsignmentEntries();
    this.hasItemEditable = orderItems.some((item: any) => item.editable); // atleast one is editable from order
    this.allItemsEditable = orderItems.every((item: any) => item.editable); // every item is editable from order
    this.isOrderClosed = order.statusCode === OrderDetailsEnum.ORDER_STATUS_CLOSED;
  }

  getAllConsignmentEntries(): any[] {
    let orderItems: any[] = [];
    this.order.consignments.forEach((consignment: any) => {
      consignment.entries.forEach((item: any) => {
        orderItems.push(item.orderEntry);
      });
    });
    return orderItems;
  }

  showCancelEditCTA(item: any, consignmentStatus: any): boolean {
    return !this.isOrderClosed && item.orderEntry?.editable && consignmentStatus !== this.consignmentsStatus.CANCELLED;
  }

  getCancelEditOrderPermission(): void {
    this.storeFrontPermissionsSubscription$ = this.myAccountPermissionService.currentUserPermissions$.subscribe(
      (permissions) => {
        this.cancelOrdersAllowed = permissions?.includes(PermissionsConstants.CANCEL_ORDERS);
        this.editOrdersAllowed = permissions?.includes(PermissionsConstants.EDIT_ORDERS);
        if (permissions !== undefined) {
          document.querySelector('cx-page-layout.OrderDetailsPageTemplate').classList.add('cancel-edit-order');
        }
        this.cdr.detectChanges();
      }
    );
  }

  showAddress(addresses: any): Observable<string> {
    return this.myAccountPersonalInforService.formatAddress(addresses);
  }

  dateFormat(): string {
    this.baseStoreSubscription$ = this.baseStoreService.getBasestoreData().subscribe((baseStoreData) => {
      this.dateFormatted = baseStoreData.dateFormat.replace(/\//g, '-');
    });
    // set default value
    return this.dateFormatted !== undefined ? this.dateFormatted : 'dd-MM-yyyy';
  }

  addFeatures(order: any): void {
    const orderType = order.orderTypeCode;

    this.features.showCreditOrderConsignmentStatus = ['CO'].includes(orderType);
    this.features.hideTrackAndTrace = ['CO'].includes(orderType);
  }

  getDeliveryDateLabelKey(statusCode: string): string {
    let key = '';
    switch (statusCode) {
      case OrderDetailsConsignmentsStatus.WAITING_PLANNED:
      case OrderDetailsConsignmentsStatus.IN_PREPARATION:
        if (this.features.displayExpectedShipmentDate) {
          key = 'myAccount.orderDetails.consignmentSummary.status.expectedShipmentDate';
        } else {
          key = 'myAccount.orderDetails.consignmentSummary.status.shipmentDate';
        }
        break;
      case OrderDetailsConsignmentsStatus.SHIPPED:
        key = 'myAccount.orderDetails.consignmentSummary.status.shipmentDate';
        break;
      case OrderDetailsConsignmentsStatus.CANCELLED:
        key = 'myAccount.orderDetails.consignmentSummary.status.deliveryDate';
        break;
      default:
        break;
    }
    return key;
  }

  ngOnDestroy() {
    this.srpSubscription$?.unsubscribe();
    this.orderDetailsSubscription$?.unsubscribe();
    this.storeFrontPermissionsSubscription$?.unsubscribe();
    this.baseStoreSubscription$?.unsubscribe();
  }
}
